jQuery(document).ready(function($) {
	//contact forms submitted
	$('.page-template-contact .wpcf7').on('wpcf7mailsent', function( event ) {

		if(urlaction && urlaction == "datasheet")
		{
			ga('send', 'event', 'request data sheet', 'submit', 'form submitted', '0');
		}
		else
		{
			ga('send', 'event', 'contact form', 'submit', 'form submitted', '0');
		}
	});

	//job apps
	$('.single-jobs .wpcf7').on('wpcf7mailsent', function( event ) {
		ga('send', 'event', 'job apps', 'submit', 'form submitted', '0');
	});

  //road-data
  $("input[type=hidden][name=_wpcf7][value=1829]").parents(".wpcf7").on('wpcf7mailsent', function( event ) {
    ga('send', 'event', 'road-data', 'submit', 'form submitted', '0');
    console.log("ga")
	});

	//newsletter subscriptions
	$('#mc-embedded-subscribe-form').on('submit', function(event){
		ga('send', 'event', 'newsletter subscription', 'submit', 'form submitted', '0');
	});
});